import axios from "axios";
import store from "../store/index";
import router from "../router/index";
import moment from "moment";
import {getApiUrl} from "@/utils/urlConfig";

axios.defaults.baseURL = getApiUrl();
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["Authorization"] =
  localStorage.getItem("user-token") || "";

export const axiosCall = async (request) => {
  var config = {};
  const api = axios.create(config);
  api.interceptors.request.use(async (request) => {
    if (
      !request.url.includes("noSpinner") &&
      (["GET", "get"].includes(request.method) ||
        request.url.includes("showSpinner"))
    ) {
      await store.dispatch("SET_IS_LOADING_DATA", true);
    }
    return request;
  });
  api.interceptors.response.use(
    async (response) => {
      await store.commit("setTokenExpirationDate", moment().add(20, "minutes"));
      if (
        !request.url.includes("noSpinner") &&
        (["GET", "get"].includes(response.config.method) ||
          response.config.url.includes("showSpinner"))
      ) {
        await store.dispatch("SET_IS_LOADING_DATA", false);
      }
      return response;
    },
    async function (error) {
      switch (error.response.status) {
        case 401:
          await store.dispatch("USERACCOUNTS_LOGOUT").then(async () => {
            await store.dispatch(
              "setError",
              "Su sesion ha terminado, vuelva a iniciar sesion"
            );
            await router.push("/");
          });
          break;
        case 412:
          break;
        default:
          await store.dispatch("setError", error.response.data.error.message);
          break;
      }
      if (
        !request.url.includes("noSpinner") &&
        (["GET", "get"].includes(error.response.config.method) ||
          error.response.config.url.includes("showSpinner"))
      ) {
        await store.dispatch("SET_IS_LOADING_DATA", false);
      }
      return Promise.reject(error);
    }
  );
  return await api.request({
    ...request,
    headers: {
      ...request.headers,
      accountRoleId: store.getters.getCurrentAccountRoleId,
    },
  });
};
